import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import RoadBuilder from "./RoadBuilder";
import SpeedLinesView from "./SpeedLinesView";

export default class RoadView extends AbstractView {

    constructor(target, gameModel, gameConfig, roadAssets) {
        super(target);
        this._model = gameModel;
        this._config = gameConfig;
        this._roadAssets = roadAssets;

        this._sectionLength = this._config.getValue("sectionLength");
        this._viewportWidth = this._config.getValue("viewport")[0];
        this._viewportHeight = this._config.getValue("viewport")[1];
        this._laneWidth = this._config.getValue("laneWidth");
        this._laneCount = this._model.getLaneCount();

        this._laneDividers = this._target.dividers;
        this._laneDividers.mouseEnabled = false;
        CacheUtil.cache(this._laneDividers);
        // this._grass = this._target.grass;
        // this._grass.mouseEnabled = false;

        this._speedLines = new SpeedLinesView(this._target.speedlines);

        this._car = this._target.car;
        this._setCarY(-this._config.getValue("carOffsetY"));
        this.setLane(this._config.getValue("start.laneIndex"), false);

        this._roadSkin = this._target.addChildAt(new createjs.Container(), 0);

        this._handleRoadClick = this._handleRoadClick.bind(this);
        const isTouch = window.ontouchstart !== undefined || getURLParameter("touch") == "1";
        this._target.addEventListener(isTouch ? "mousedown" : "click", this._handleRoadClick);
        this._target.mouseChildren = false;

        this._cameraOffset = 0;
    }

    destroy() {
        this._target.removeEventListener("click", this._handleRoadClick);
    }

    /**
     * @param {RoadBuilder} roadBuilder 
     */
    createRoad(roadBuilder) {
        this._roadSkin.removeAllChildren();
        //build road layers
        //. lanes
        const sectionsContainer = this._roadSkin.addChild(new createjs.Container());
        //. vertical lane dividers
        let p = this._laneDividers.localToLocal(0, 0, this._roadSkin);
        this._laneDividers.y = p.y;
        this._roadSkin.addChild(this._laneDividers);
        this._laneDividers.yOrig = this._laneDividers.y;
        //. horizontal section divider
        this._sectionDivider = this._roadSkin.addChild(new this._roadAssets.SectionDividerSkin());
        //. markers (e.g., horizontal bands for start and finish)
        const markersContainer = this._roadSkin.addChild(new createjs.Container());
        //. grass
        // p = this._grass.localToLocal(0, 0, this._roadSkin);
        // this._grass.y = p.y;
        // this._roadSkin.addChild(this._grass);
        // this._grass.yOrig = this._grass.y;

        this.sectionSkins = roadBuilder.build(sectionsContainer, markersContainer, this._model.level);

        this._sectionFinish = this.sectionSkins.find(sectionSkin => sectionSkin.laneTypes.indexOf("EE") > -1);
        this._updateSectorCulling();
        this._syncSectionDivider();
    }

    enableInteraction(bool) {
        this._interactionEnabled = bool;
    }

    /**
     * 
     * @param {Number} dy
     */
    moveCamera(dy) {
        this.setCameraOffset(this._cameraOffset + dy);
    }

    setCameraOffset(value) {
        this._cameraOffset = value;
        this._setCarY(-this._config.getValue("carOffsetY") - this._cameraOffset);
    }

    _setCarY(y) {
        this._car.y = y;
        this._speedLines.y = this._car.y;
    }

    setOffset(offset) {
        offset -= this._cameraOffset;
        this._laneDividers.y = this._laneDividers.yOrig - offset + (offset % 144);
        //this._grass.y = this._grass.yOrig - offset + (offset % 2077);
        this._roadSkin.y = offset;
        this._updateSectorCulling();
        this._syncSectionDivider();
        this._speedLines
    }

    setSpeed(speed) {
        this._car.gas.visible = speed > .1;
        if (this._car.gas.visible && this._car.gas.paused) {
            this._car.gas.play();
        }
    }

    _syncSectionDivider() {
        const sections = this.sectionSkins.filter(sectionSkin => sectionSkin.visible);
        const currentSection = sections[sections.length - 1];
        const p = currentSection.localToLocal(0, 0, this._roadSkin);
        this._sectionDivider.y = p.y;
    }

    _updateSectorCulling() {
        const p = new createjs.Point();//reuse
        this._currentSectionIdx = null;
        this.sectionSkins.forEach(sectionSkin => {
            sectionSkin.localToLocal(0, 0, this._target, p);
            //p.y is bottom y of section 
            sectionSkin.visible = p.y >= -this._viewportHeight && p.y <= this._sectionLength;
            if (p.y >= this._car.y && p.y - this._sectionLength < this._car.y) {
                this._currentSectionIdx = this.sectionSkins.indexOf(sectionSkin);
            }
        });
    }

    setLane(idx, animate = true) {
        if (this._lane == idx) {
            return;
        }
        this._lane = Math.min(this._laneCount - 1, Math.max(0, idx));
        let goalX = (this._lane - Math.floor(this._laneCount / 2)) * this._laneWidth;
        if (this._laneCount % 2 == 0) {
            goalX += .5 * this._laneWidth;
        }
        this._moveCar(goalX, animate);
    }

    getLaneForX(stageX) {
        const { x } = this._target.globalToLocal(stageX, 0);
        const x0 = -(this._laneCount / 2) * this._laneWidth;
        const idx = Math.floor((x - x0) / this._laneWidth);
        return idx;
    }

    _moveCar(goalX, animate) {
        if (!animate) {
            this._car.x = goalX;
        } else {
            const dx = this._car.x - goalX;
            const dur = this._config.getValue("laneSwitchDuration");
            createjs.Tween.get(this._car).to({ x: goalX }, dur, createjs.Ease.quadOut);
            const rot = 9;
            createjs.Tween.get(this._car)
                .to({ rotation: dx < 0 ? rot : -rot }, dur, createjs.Ease.backIn)
                .to({ rotation: 0 }, dur, createjs.Ease.backOut);
            
            this._speedLines.animate(this._car.x, goalX, dur * .6);
        }
    }

    _handleRoadClick(e) {
        if (this._interactionEnabled) {
            const idx = this.getLaneForX(e.stageX);
            if (idx >= 0 && idx < this._laneCount) {
                this.dispatchEvent(RoadView.JUMP, idx);
            }
        }
    }
}

RoadView.JUMP = "RoadView.JUMP";